import { render, staticRenderFns } from "./children_data.vue?vue&type=template&id=1dfc0a9d&"
import script from "./children_data.vue?vue&type=script&lang=js&"
export * from "./children_data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports